"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _common = require("../styles/common");
const _excluded = ["disabled", "onClick", "children"];
/*
TODOs:
- Focus styles
*/
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Variant = /*#__PURE__*/function (Variant) {
  Variant["primary"] = "primary";
  Variant["secondary"] = "secondary";
  return Variant;
}(Variant || {});
// TODO: Disable hover animations on disabled buttons

const hoverStyles = (0, _styledComponents.css)`
    ${props => !props.disabled && (0, _styledComponents.css)`
        &.hover,
        &:hover {
            filter: brightness(90%);
        }

        &.active,
        &:active {
            filter: brightness(80%);
        }
    `}
`;
const primaryStyles = (0, _styledComponents.css)`
    color: white;
    background-color: var(--vcs-color--primary);
    border: 1px solid var(--vcs-color--primary-border);
    ${hoverStyles}
`;
const secondaryStyles = (0, _styledComponents.css)`
    color: var(--btn-text-color);
    background-color: var(--btn-bg-color);
    border: 1px solid var(--btn-border-color);
    ${hoverStyles}
`;
const StyledButton = _styledComponents.default.button.attrs(props => ({
  type: props.type || 'button'
}))`
    display: inline-flex;
    align-items: center;
    justify-content: center;

    position: relative;
    background: transparent;
    transition: all 0.4s ease;

    padding: 0 16px;
    line-height: 32px;
    /* min-width: 140px; // Dialog only. 100 on secondary buttons */

    border-radius: 2px;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    ${props => props.variant === Variant.primary ? primaryStyles : secondaryStyles}
    ${props => props.disabled && _common.disabled}

    :hover {
        cursor: pointer;
    }
`;
const Button = _ref => {
  let {
      disabled,
      onClick,
      children
    } = _ref,
    extra = _objectWithoutProperties(_ref, _excluded);
  const handleClick = () => !disabled && onClick();
  return /*#__PURE__*/_react.default.createElement(StyledButton, _extends({
    disabled: disabled,
    "aria-disabled": disabled,
    onClick: onClick,
    onKeyDown: ({
      code
    }) => code === "Enter" && handleClick()
  }, extra), children);
};

//beforeText
//afterText
exports.Button = Button;
Button.propTypes = {
  children: _propTypes.default.node,
  /** Prevent onClick event, add disabled styles */disabled: _propTypes.default.bool,
  /** The function that click executes */onClick: _propTypes.default.func,
  /** Styles the button */variant: _propTypes.default.oneOf(["primary", "secondary"])
};
Button.defaultProps = {
  disabled: false,
  variant: Variant.primary,
  onClick: console.log
};